import React, { useState } from 'react';
import { Gauge } from 'lucide-react';

const MileageDisplay = ({ 
  mileage = 0, 
  showUnitToggle = true, 
  size = 'normal',
  className = "" 
}) => {
  const [unit, setUnit] = useState('miles');

  const convertMileage = (value, fromUnit, toUnit) => {
    if (fromUnit === toUnit) return value;
    if (fromUnit === 'miles' && toUnit === 'km') {
      return Math.round(value * 1.60934);
    } else if (fromUnit === 'km' && toUnit === 'miles') {
      return Math.round(value / 1.60934);
    }
    return value;
  };

  const handleUnitChange = (newUnit) => {
    if (newUnit !== unit) {
      setUnit(newUnit);
    }
  };

  const formatMileage = (value, unit) => {
    return `${value.toLocaleString()} ${unit}`;
  };

  const displayMileage = unit === 'km' 
    ? convertMileage(mileage, 'miles', 'km')
    : mileage;

  const sizeClasses = {
    small: 'text-sm',
    normal: 'text-base',
    large: 'text-lg',
    xlarge: 'text-xl'
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Gauge className={`text-ink-muted ${size === 'small' ? 'w-3 h-3' : size === 'large' ? 'w-5 h-5' : 'w-4 h-4'}`} />
      
      <div className="flex items-center gap-2">
        <span className={`font-medium ${sizeClasses[size]}`}>
          {formatMileage(displayMileage, unit)}
        </span>
        
        {unit === 'km' && (
          <span className={`text-ink-muted ${sizeClasses[size]}`}>
            ({formatMileage(mileage, 'miles')})
          </span>
        )}
      </div>

      {showUnitToggle && (
        <div className="flex items-center gap-1">
          <button
            onClick={() => handleUnitChange('miles')}
            className={`px-1.5 py-0.5 text-small rounded transition-colors ${
              unit === 'miles' 
                ? 'bg-accent/10 text-accent font-medium' 
                : 'bg-surface-muted text-ink-muted hover:bg-surface-muted'
            }`}
          >
            mi
          </button>
          <button
            onClick={() => handleUnitChange('km')}
            className={`px-1.5 py-0.5 text-small rounded transition-colors ${
              unit === 'km' 
                ? 'bg-accent/10 text-accent font-medium' 
                : 'bg-surface-muted text-ink-muted hover:bg-surface-muted'
            }`}
          >
            km
          </button>
        </div>
      )}
    </div>
  );
};

export default MileageDisplay;
